<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Dashboard-DNA"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="AI-Profiler---Cards" transform="translate(-457, -532)">
        <g id="Group-13" transform="translate(457, 532)">
          <circle id="Oval" fill="#1B1E1E" cx="12" cy="12" r="12"></circle>
          <g
            id="male_24dp_FILL1_wght400_GRAD0_opsz24"
            transform="translate(6, 6)"
            fill="#95A7A3"
            fill-rule="nonzero"
          >
            <path
              id="Shape"
              d="M12,0 L12,4.5 L10.5,4.5 L10.5,2.56875 L7.51875,5.53125 C7.75625,5.88125 7.9375,6.253125 8.0625,6.646875 C8.1875,7.040625 8.25,7.45 8.25,7.875 C8.25,9.025 7.85,10 7.05,10.8 C6.25,11.6 5.275,12 4.125,12 C2.975,12 2,11.6 1.2,10.8 C0.4,10 0,9.025 0,7.875 C0,6.725 0.4,5.75 1.2,4.95 C2,4.15 2.975,3.75 4.125,3.75 C4.5375,3.75 4.94375,3.809375 5.34375,3.928125 C5.74375,4.046875 6.1125,4.23125 6.45,4.48125 L9.43125,1.5 L7.5,1.5 L7.5,0 L12,0 Z M4.125,5.25 C3.4,5.25 2.78125,5.50625 2.26875,6.01875 C1.75625,6.53125 1.5,7.15 1.5,7.875 C1.5,8.6 1.75625,9.21875 2.26875,9.73125 C2.78125,10.24375 3.4,10.5 4.125,10.5 C4.85,10.5 5.46875,10.24375 5.98125,9.73125 C6.49375,9.21875 6.75,8.6 6.75,7.875 C6.75,7.15 6.49375,6.53125 5.98125,6.01875 C5.46875,5.50625 4.85,5.25 4.125,5.25 Z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
